import AddIcon from '@mui/icons-material/Add';
import { Box, Checkbox, Modal, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CLOSE_ICON from '../../assets/svg/close-icon.svg';
import { LANG_TEXT } from '../../constants/language';
import Button from '../Button/Button';
import { buttonAddCategory, confirmButtonStyle, useStyles } from '../ManageCategoryModal/styles';
import { categoryCardStyle, categoryTitleStyle, checkboxStyle, gridContainerStyle } from './styles';

interface CategorySimple {
  id: string;
  title: string;
  foodIds?: string[];
  order?: number;
  enabled?: boolean;
}

interface Props {
  open: boolean;
  handleClose: () => void;
  categories: CategorySimple[];
  selectedCategoryIds?: string[];
  partialCategoryIds?: string[];
  onSelectCategory: (categoryIds: string[], toggledCategoryId?: string) => void;
  onConfirm: () => void;
  onAddNewCategory?: () => void;
}

const MoveToCategoryModal: React.FC<Props> = ({
  open,
  handleClose,
  categories,
  selectedCategoryIds = [],
  partialCategoryIds = [],
  onSelectCategory,
  onConfirm,
  onAddNewCategory,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleToggleCategory = (categoryId: string) => {
    const isSelected = selectedCategoryIds.includes(categoryId);
    const isPartial = partialCategoryIds.includes(categoryId);

    if (!isSelected && !isPartial) {
      onSelectCategory([...selectedCategoryIds, categoryId], categoryId);
    } else {
      onSelectCategory(
        selectedCategoryIds.filter((id) => id !== categoryId),
        categoryId
      );
    }
  };

  return (
    <Modal className={classes.Modal} open={open} onClose={handleClose} aria-labelledby="move-to-category-title">
      <Box className={classes.Box}>
        <Box className={classes.BoxHeader}>
          <Box className={classes.BoxTitleModal}>
            <Box className={classes.TitleModal}>
              <Typography fontSize={18} fontWeight={600} lineHeight={'28px'} color={'var(--Gray-900, #101828)'}>
                {t(LANG_TEXT.MANAGE_CATEGORY)}
              </Typography>
            </Box>
            <Box className={classes.IconClose} onClick={handleClose}>
              <img src={CLOSE_ICON} height={20} width={20} alt="CLOSE_ICON" />
            </Box>
          </Box>
        </Box>

        <Box className={classes.BoxContent}>
          <Box sx={gridContainerStyle}>
            {categories.map((c) => {
              const isSelected = selectedCategoryIds.includes(c.id);
              const isPartial = partialCategoryIds.includes(c.id);

              return (
                <Box key={c.id} sx={categoryCardStyle(isSelected)} onClick={() => handleToggleCategory(c.id)}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Checkbox
                      checked={isSelected}
                      indeterminate={isPartial && !isSelected}
                      onChange={() => handleToggleCategory(c.id)}
                      onClick={(e) => e.stopPropagation()}
                      sx={checkboxStyle}
                    />
                    <Typography sx={categoryTitleStyle(isSelected)}>{c.title || ''}</Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>

        <Box className={classes.BoxFooter}>
          <Button
            boxStyle={{
              width: 'max-content !important',
            }}
            id="done_button"
            fullWidth={false}
            title={t(LANG_TEXT.CONFIRM)}
            buttonStyle={confirmButtonStyle}
            sxTextStyle={{ color: 'var(--Base-White, #FFF)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={onConfirm}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default MoveToCategoryModal;
